// queries/useGetAllCreations.ts
"use client";
import { useInfiniteQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_CREATIONS } from "api";

// Adjust the fetchGenerations function to accept pagination parameters
const fetchGenerations = async (
  pageParam: number = 1,
  pageSize: number = 16,
  tags: string[] = []
) => {
  let tagsQueryParams = "";
  if (tags.length > 0) {
    tagsQueryParams = tags.map((tag) => `model_tag=${encodeURIComponent(tag)}`).join("&");
  }

  const queryString = `page=${pageParam}&page_size=${pageSize}${
    tagsQueryParams ? `&${tagsQueryParams}` : ""
  }`;

  return fetch(`${GET_CREATIONS}?${queryString}`);
};

// Update the hook to use useInfiniteQuery
export const useGetAllGenerations = (pageSize: number, tags: string[]) => {
  // @ts-ignore
  return useInfiniteQuery({
    queryKey: ["generations", { tags }],
    queryFn: ({ pageParam = 1 }) => fetchGenerations(pageParam as any, pageSize, tags),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      // Replace with actual logic to determine if there is a next page
      // @ts-ignore
      return nextPage <= Math.ceil(lastPage.total_models / pageSize) ? nextPage : undefined;
    },
  });
};

export default useGetAllGenerations;
